export const ADDRESS_CONFIRMED = 'address_confirmed'
export const ADDRESS_VERIFIED = 'address_verified'
export const DISTRICT_ERROR = 'district_error'
export const GENERATE_FAIL_ERR_MSG = 'Generate districts failed'
export const GENERATING_DISTRICTS = 'generating_districts'
export const VALIDATING_ADDRESS = 'validating_address'
export const WAITING_ADDRESS_CONF = 'waiting_address_conf'
